/**
 * SHA-256 hex digest for Datadog identifiers (same logic as legacy in-app user id hashing).
 * Passes through the literal "Anonymous" unchanged.
 */
export const hashUserId = async (rawId: string): Promise<string> => {
  if (rawId === 'Anonymous') return 'Anonymous';

  const cryptoRef = typeof globalThis !== 'undefined' && 'crypto' in globalThis ? globalThis.crypto : undefined;

  if (!cryptoRef?.subtle) {
    return 'Unknown';
  }

  const encoded = new TextEncoder().encode(rawId);
  const digest = await cryptoRef.subtle.digest('SHA-256', encoded);
  return Array.from(new Uint8Array(digest))
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');
};
